import React from "react";
import AdminLogs from "../components/AdminLogs";

const AdminLogsPage: React.FC = () => {
  return (
    <div>
      <AdminLogs />
    </div>
  );
};

export default AdminLogsPage;
